import "./Contact.css"

const Contact = ()=>
{
    return(
        <div className="contact">
            <h1>Contact <span>Me</span></h1>
            <div className="details">

                <div>
                    <strong>Email : </strong>
                    <p className="aaa"><a href="mailto:dhineshkandhasamy2005@gmail.com">Click to mail</a></p>
                    
                </div>

                <div>
                    <strong>Phone : </strong>
                    <p className="aaa"> +91 6382476264</p>
                </div>

                <div>
                    <strong>Location : </strong>
                    <p className="aaa"> Dindigul, Tamil Nadu, India</p>
                </div>

                <div>
                    <strong>Leetcode : </strong>
                    <a href="https://leetcode.com/u/Dhineshkandhasamy" target="new" className="aaa">Click to leetcode </a>
                </div>

                <div>
                    <strong>GitHub<i class="fa-brands fa-github"></i>: </strong>
                    <a href="https://github.com/DHINESHKUMAR2305" target="new" className="aaa">Click to github</a>
                </div>

                <div>
                    <strong>LinkedIn<i class="fa-brands fa-linkedin"></i> : </strong>
                    <a href="https://www.linkedin.com/in/dhineshkandhasamy" target="new" className="aaa">Click to linkedin</a>
                </div>
            </div>
        </div>
    )
}

export default Contact